<template>
    <v-container>
        <v-card outlined>
        <v-card-subtitle class="pb-0">
            <v-row>
               <v-col cols="4"> <v-text-field label="เลขที่ตั้งเบิก" v-model="withdrawNo" placeholder=" " outlined></v-text-field></v-col>
            </v-row>
            <v-row><v-col> วันที่ตั้งเบิก </v-col> </v-row>
            <v-row>
                <v-col cols="2"><DatePicker label="ตั้งแต่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                <v-col cols="2"><DatePicker label="ถึง" @dateFormatted="setDateTo" ></DatePicker></v-col>
                <v-spacer></v-spacer>
                <v-col class="text-right">
                    <v-row>
                        <v-btn  class="ma-2" color="primary"  @click="search" small><v-icon>search</v-icon> ค้นหา</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-subtitle>
    </v-card>
                <v-dialog v-model="viewDialog" width="1000">
                    <EditWithdraw ref="edit" :withdrawData="withdrawData" @closeDialog="close"></EditWithdraw> 
                </v-dialog>
    <v-data-table
        :headers="headers"
        :items="items"
        class="pt-5"
        >
       
            <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    @click="viewWithdraw(item)"
                >
                    search
                </v-icon>
            </template>
    
    </v-data-table>
    </v-container>
</template>

<script>

import DatePicker from '@/components/Shared/DatePicker'
import {listWithdraw,listItemByWithdrawNo} from '@/api/accounting/withdraw-api.js'
import EditWithdraw from './EditWithdraw'
import numeral from 'numeral'
export default {
    name: 'View11',
    components: {
        DatePicker,
        EditWithdraw
    },
    props: ["branchCode"],
    data: () => ({
       viewDialog: false,
       headers: [
            {text: "เลขที่ตั้งเบิก", value: "withdrawNo"},
            {text: "ช่วงเวลา", value: "rankDate"},
            {text: "วันที่ตั้งเบิก", value: "strWithdrawDate"},
            {text: "จำนวนรายการ", value: "trnCount"},
            {text: "ยอดสุทธิ", value: "trnTotalDisplay"},
            {text: "ยอดเบิก", value: "trnGrandTotalDisplay"},
            {text: "เจ้าหน้าที่", value: "employee"},
           // {text: "หมายเหตุ", value: "remark"},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [

        ],
        dateFrom: null,
        dateTo: null,
        withdrawNo:'',
        withdrawData:[]
    }),
    methods: {
        setDateFrom(val) {
            this.dateFrom = val;
        },
        setDateTo(val) {
            this.dateTo = val;
        },
        // addClick() {
        //     this.$emit("addClick");
        // },
        search(){
           this.listItem();
        } ,
        listItem() {
            //this.items =[];
            this.$loading(true);
            listWithdraw(this.withdrawNo,this.dateFrom,this.dateTo,this.branchCode).then(response => {
                this.items = response;
            if (this.items) {
                this.items.forEach((e) => {
                    e.trnTotalDisplay = numeral(e.trnTotal).format('0,0.00');
                    e.trnGrandTotalDisplay = numeral(e.trnGrandTotal).format('0,0.00');
                                        
                });
             }
                this.$loading(false);

            }).catch(()=> {
                this.$loading(false);
            });
        },
        viewWithdraw(item){
            this.withdrawData = item;

           listItemByWithdrawNo(item.withdrawNo).then(response => {               
              this.$loading(false);             
              this.viewDialog = true;
               this.$nextTick(() => {
                    this.$refs.edit.setItems(response);
                })
                
           }).catch(()=> {
               this.$loading(false);
           });
            
            this.viewDialog = true;
            
        },
        close() {
            this.viewDialog = false;
           // this.withdrawNo ='';
            this.search();
        }
    }
}
</script>